import { SESSION_STORAGE_AUTH_TOKEN, getSessionStorageItem, setSessionStorageItem } from './sessionStorage';
import { jwtDecode } from "jwt-decode";
import * as Sentry from "@sentry/react";

const covrAuthUrl = window.__ENV__.REACT_APP_AUTH_SERVICE_URL;

let lastRefresh = null;

const GRANT_TYPE = {
  accessToken: 'access_token',
  authorizationCode: 'authorization_code',
};

export const getAuthToken = () => {
  return getSessionStorageItem(SESSION_STORAGE_AUTH_TOKEN) || '';
}

export const setAuthToken = (token) => {
  setSessionStorageItem(SESSION_STORAGE_AUTH_TOKEN, token);
}

export const validateToken = async () => {
  const response = await fetch(`${covrAuthUrl}/verify`, {
    method: 'POST',
    body: JSON.stringify({
      accessToken: getAuthToken(),
    }),
  });

  if (!response.ok) {
    Sentry.captureMessage("Token validation failed - redirect /ns", {
      level: "warning",
      extra: {
        token: getAuthToken(),
        status: response.status
      },
    });
    window.location.href = '/ns';
  }

  return response.ok;
};

export const refreshToken = async () => {
  const now = Date.now();
  if (lastRefresh === null || now - lastRefresh >= 60 * 1000) { // if at least 1 minute since last refresh
    lastRefresh = now;
    await tokenRequest(getAuthToken(), GRANT_TYPE.accessToken);
  }
}

export const redeemCode = async (code) => tokenRequest(code, GRANT_TYPE.authorizationCode);

const tokenRequest = async (token, grantType) => {
  const response = await fetch(`${covrAuthUrl}/token`, {
    method: 'POST',
    body: JSON.stringify({
      token,
      grantType,
    }),
  });

  const responseObj = await response.json();

  if (!responseObj.isSuccessful) {
    throw new Error(`Token request failed: [${responseObj.errorCode}] ${responseObj.errorDescription}`);
  }

  setAuthToken(responseObj.accessToken);
  return responseObj.accessToken;
};

// Return remaining time in seconds
export const getTokenRemainingTime = () => {
  const token = getAuthToken();
  if (!token) {
    return 0;
  }
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    const remainingTime = decodedToken.exp - currentTime;
    return remainingTime > 0 ? remainingTime : 0; // Return remaining time or 0 if expired
  } catch (error) {
    console.error('Error decoding token or calculating remaining time:', error);
    return 0;
  }
};

export const getNameID = () => {
  const token = getAuthToken();
  if (!token) {
    return '';
  }
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken.sub;
  } catch (error) {
    console.error('Error decoding token:', error);
    return '';
  }
};


// WEBPACK FOOTER //
// ./src/auth.js